import { render, staticRenderFns } from "./ImportFromImage.vue?vue&type=template&id=476c6329&scoped=true"
import script from "./ImportFromImage.vue?vue&type=script&lang=js"
export * from "./ImportFromImage.vue?vue&type=script&lang=js"
import style0 from "./ImportFromImage.vue?vue&type=style&index=0&id=476c6329&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c6329",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476c6329')) {
      api.createRecord('476c6329', component.options)
    } else {
      api.reload('476c6329', component.options)
    }
    module.hot.accept("./ImportFromImage.vue?vue&type=template&id=476c6329&scoped=true", function () {
      api.rerender('476c6329', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ImportFromImage.vue"
export default component.exports